import { useState } from 'react';
import { esopApi } from '../services/api';
import '../styles/Modal.css';

function UploadESOPModal({ entity, onClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExt = selectedFile.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(fileExt)) {
        setError('Please select an Excel file (.xlsx or .xls)');
        setFile(null);
        return;
      }
      setFile(selectedFile);
      setError(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError('Please select a file to upload');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await esopApi.uploadData(entity.name, file);

      const warnings = result.summary?.warnings || [];
      const warningText = warnings.length > 0
        ? `\n\nWarnings:\n${warnings.join('\n')}`
        : '';

      setSuccess(
        `ESOP data uploaded successfully!\n\n` +
        `Grants: ${result.summary?.grants || 0}\n` +
        `Valuations: ${result.summary?.valuations || 0}\n` +
        `NAV Records: ${result.summary?.nav_records || 0}` +
        warningText
      );

      setTimeout(() => {
        onSuccess();
      }, 2000);
    } catch (err) {
      setError(err.message || 'Failed to upload ESOP data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Upload ESOP Data</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Entity:</label>
              <input
                type="text"
                value={entity.name}
                disabled
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Select Excel File:</label>
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="form-control"
                disabled={loading}
              />
              <small className="form-help">
                Upload the filled ESOP template with grant data, valuation parameters, and NAV data
              </small>
            </div>

            {file && (
              <div className="file-info">
                <strong>Selected File:</strong> {file.name}
                <br />
                <strong>Size:</strong> {(file.size / 1024).toFixed(2)} KB
              </div>
            )}

            {error && (
              <div className="alert alert-error">
                {error}
              </div>
            )}

            {success && (
              <div className="alert alert-success" style={{ whiteSpace: 'pre-line' }}>
                {success}
              </div>
            )}

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !file}
              >
                {loading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UploadESOPModal;
